import AddPatientModal from './AddPatientModal';

export default AddPatientModal;
